import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Header, Icon, Button, Table, Label, Checkbox } from "semantic-ui-react";
import { getPaymentsForUser } from "services/payment";
import DatePicker from "react-datepicker";
import moment from "moment";
import Select from "react-select";
import { toast } from "react-toastify";

const styles = {
	blocWhite: {
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		backgroundColor: "#fff",
		padding: 20,
		borderRadius: "0 0 4px 4px",
		overflowY: "auto",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
		color: "white",
	},
	select2: {
		container: (provided) => ({
			...provided,
			width: "280px",
			cursor: "pointer",
			margin: "5px 0",
			fontSize: "0.9rem",
			color: "teal",
			height: 38,
			paddingRight: 10,
		}),
		option: (provided) => ({
			...provided,
			cursor: "pointer",
			textAlign: "left",
		}),
		control: (provided) => ({
			...provided,
			cursor: "pointer",
		}),
	},
};

const CashSheet = () => {
	const [startDate, setStartDate] = useState(new Date());
	const [endDate, setEndDate] = useState(new Date());
	const [totalAmount, setTotalAmount] = useState(0);
	const [paymentsByFolder, setPaymentsByFolder] = useState([]);
	const [selectedMode, setSelectedMode] = useState(null);
	const [refresh, setRefresh] = useState(0);
	const [myCenter, setMyCenter] = useState(false);
	const dispatch = useDispatch();
	const user = useSelector((state) => state.user);
	useEffect(() => {
		dispatch(
			getPaymentsForUser(startDate, endDate, 1, 200, "", user?.session?.center?.id, "", myCenter ? null : user.session?.id, selectedMode?.value)
		).then((res) => {
			if (res && res.payload && res.payload.data && res.payload.data.payments) {
				setTotalAmount(res.payload.data.totalAmount);
				getPaymentsByFolder(res.payload.data.payments);
			}
		});
	}, [startDate, endDate, selectedMode, refresh, myCenter]);

	const c = user?.session?.center;
	const getPaymentsByFolder = (payments) => {
		let result = payments?.reduce((acc, payment) => {
			if (
				!acc.some(
					(c) =>
						(payment.folder &&
							c.code === payment.folder.code &&
							moment(payment.created_at).format("DD/MM/YYYY") === moment(c.date).format("DD/MM/YYYY")) ||
						(!payment.folder &&
							payment.casing &&
							c.casing === payment.casing.id &&
							moment(payment.created_at).format("DD/MM/YYYY") === moment(c.date).format("DD/MM/YYYY"))
				)
			) {
				acc.push({
					code: payment.folder?.code,
					patient: payment.folder
						? payment.folder?.patient?.birth_name?.toUpperCase() + " " + payment.folder?.patient?.first_name
						: payment.casing?.patient_name,
					cash: payment.source === "especes" ? payment.price : 0,
					servipay: payment.source === "servipay" ? payment.price : 0,
					sumup: payment.source === "sumup" ? payment.price : 0,
					toBill: payment.source === "toBill" ? payment.price : 0,
					date: payment.created_at,
					cashier: `${payment.cashier.first_name} ${payment.cashier.last_name}`,
					casing: payment.casing?.id,
					invoice_reference: payment.invoice_reference,
				});
			} else {
				acc = acc.map((c) => {
					if (
						moment(payment.created_at).format("DD/MM/YYYY") === moment(c.date).format("DD/MM/YYYY") &&
						((payment.folder && c.code === payment.folder?.code) || (payment.casing && c.casing === payment.casing?.id))
					) {
						if (payment.source === "especes") {
							c.cash += payment.price;
						}
						if (payment.source === "servipay") {
							c.servipay += payment.price;
						}
						if (payment.source === "sumup") {
							c.sumup += payment.price;
						}

						if (c.invoice_reference && payment.invoice_reference && !c.invoice_reference.includes(payment.invoice_reference)) {
							c.invoice_reference += " / " + payment.invoice_reference;
						}
					}

					return c;
				});
			}
			return acc;
		}, []);
		setPaymentsByFolder(result);
	};
	const getPaymentAvailable = (c) => {
		let result = [];
		if (c.servipayAvailable) result.push({ value: "servipay", label: "Servipay" });
		if (c.cashAvailable) result.push({ value: "especes", label: "Espèces" });
		if (c.sumupAvailable) result.push({ value: "sumup", label: "Sumup" });
		return result;
	};

	return (
		<Grid textAlign="left" style={{ height: "100vh" }} verticalAlign="top">
			<Grid.Column style={{ padding: 40, height: "93vh" }}>
				<Header as="h2" color="teal" textAlign="center" style={{ backgroundColor: "rgb(0, 147, 128)", borderRadius: "4px" }}>
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "baseline",
							color: "white",
							backgroundColor: "rgb(67, 179, 158)",
							padding: "10px",
							borderRadius: "4px",
						}}
					>
						<div style={{ fontSize: "0.7em" }}>Résumé d'encaissement </div>
						<div style={{ display: "flex", justifyContent: "flex-end", alignItems: "baseline", fontSize: "0.8em" }}>
							<Checkbox
								style={{ marginRight: "5px", paddingTop: "5px" }}
								checked={myCenter}
								onMouseDown={(e) => {
									setMyCenter(!myCenter);
									e.preventDefault();
									e.stopPropagation();
								}}
							/>
							<span style={{ fontSize: "0.8rem", width: "65px", paddingRight: "7px" }}>Mon centre</span>
							<Select
								isClearable
								name="mode"
								customlabel="Mode de paiement"
								value={selectedMode}
								options={getPaymentAvailable(c)}
								onChange={(c) => setSelectedMode(c)}
								styles={styles.select2}
								placeholder="Sélectionner un mode de paiement"
							/>
							<Icon name="calendar alternate" style={styles.icon} />
							Du{" "}
							<div style={{ width: "125px", fontSize: "0.9em", padding: "0 10px" }}>
								<DatePicker
									selected={new Date(startDate)}
									className="datePicker"
									onChange={(date) => {
										let minDate = moment().add(-30, "days");
										if (moment(date).isBefore(minDate)) toast.warn("La date de début ne peut pas être antérieure à 30 jours");

										setStartDate(moment(date).isBefore(minDate) ? new Date(minDate) : date);
									}}
									shouldCloseOnSelect={true}
									dateFormat={process.env.REACT_APP_DATE_DATEPICKER}
								/>
							</div>
							<div> au </div>
							<div style={{ width: "125px", fontSize: "0.9em", padding: "0 10px" }}>
								<DatePicker
									selected={new Date(endDate)}
									className="datePicker"
									onChange={(date) => {
										setEndDate(date);
									}}
									shouldCloseOnSelect={true}
									dateFormat={process.env.REACT_APP_DATE_DATEPICKER}
								/>
							</div>
						</div>
						<Button icon color="teal" size="tiny" onClick={() => setRefresh(refresh + 1)}>
							<Icon name="refresh" />
						</Button>
					</div>
				</Header>

				<div style={styles.blocWhite}>
					{paymentsByFolder.length > 0 && (
						<div>
							<div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "baseline" }}>
								{totalAmount > 0 && (
									<div>
										<span>
											Montant total : {totalAmount.toFixed(2)}
											{` €`}
										</span>
									</div>
								)}
							</div>
							<Table sortable celled fixed>
								<Table.Header>
									<Table.Row>
										{myCenter && <Table.HeaderCell>Encaissé par</Table.HeaderCell>}
										<Table.HeaderCell>Dossier</Table.HeaderCell>
										<Table.HeaderCell>Montant</Table.HeaderCell>
										<Table.HeaderCell>Mode de paiement</Table.HeaderCell>
										<Table.HeaderCell>Date</Table.HeaderCell>
									</Table.Row>
								</Table.Header>
								<Table.Body>
									{paymentsByFolder.length > 0 &&
										paymentsByFolder
											.filter((p) => p.cash + p.servipay + p.sumup + p.toBill > 0)
											.map((p, index) => (
												<Table.Row key={`${p.code}-${index}`}>
													{myCenter && <Table.Cell>{p.cashier}</Table.Cell>}
													<Table.Cell textAlign="right">
														<strong>{p.code || "Paiement direct"}</strong>
														<br />
														{p.invoice_reference && `Facture${p.invoice_reference.includes("/") ? "s" : ""} : ${p.invoice_reference}`}
														{p.invoice_reference && <br />}
														<span style={{ fontSize: "0.8em" }}>{p.patient}</span>
													</Table.Cell>
													<Table.Cell>
														<strong>{(p.cash + p.servipay + p.sumup + p.toBill).toFixed(2)}€</strong>
													</Table.Cell>
													<Table.Cell>
														{p.cash > 0 && <Label> {p.cash.toFixed(2)}€ en espèces </Label>}
														{p.servipay > 0 && <Label> {p.servipay.toFixed(2)}€ via Servipay </Label>}
														{p.sumup > 0 && <Label> {p.sumup.toFixed(2)}€ via Sumup </Label>}
														{p.toBill > 0 && <Label> {p.toBill.toFixed(2)}€ à facturer </Label>}
													</Table.Cell>
													<Table.Cell>{moment(p.date).format("DD/MM à HH:mm")}</Table.Cell>
												</Table.Row>
											))}
								</Table.Body>
							</Table>
						</div>
					)}
					{paymentsByFolder.length === 0 && "Aucun paiement pour cette période"}
				</div>
			</Grid.Column>
		</Grid>
	);
};

export default CashSheet;
